export const Horario24 = () => {
  const horario = [];
  for (let i = 0; i < 24; i++) {
    horario.push(i < 10 ? `0${i}:00` : `${i}:00`);
  }
  return horario;
};


export const Time24 = () => {
  const horario = [];
  for (let i = 1; i <= 24; i++) {
    horario.push(i);
  }
  return horario;
}